<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-type="flex" vs-w="6" style="flex-direction: column;">
        <div
          v-if="posIpSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Pos Cihazı Ayarı</span>
          </div>
          <form data-vv-scope="form-pos-ip-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <vs-col vs-w="6" >
              <span class="weight-600">Durum :</span>
              <vs-switch class="ml-2" v-model="posIpSettings.enable">
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-col>
            <vs-col vs-w="6" >
              <span class="weight-600"> Entegrasyon Tipi : </span><br /> 
              <vs-radio v-model="posIpSettings.posType" vs-value="0" class="mr-6" vs-name="footer-type-hidden">REST</vs-radio>
              <vs-radio v-model="posIpSettings.posType" vs-value="1" class="mr-6" vs-name="footer-type-static">GMP3</vs-radio>
            </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                IP Adresi (192.168.1.1)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:
                    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])+$/,
                }"
                name="IP Adresi"
                placeholder="IP Adresi"
                v-model="posIpSettings.deviceUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.IP Adresi")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                Port (7500)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5])$/
              }"
                name="Device Port"
                placeholder="Device Port"
                v-model="posIpSettings.devicePort"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.Device Port")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                API Url (https://localhost)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}$/

                  }"
                name="API URL"
                placeholder="API URL"
                v-model="posIpSettings.apiUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.API URL")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
               API Port (7500)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5])$/
              }"
                name="Api Port"
                placeholder="API Port"
                v-model="posIpSettings.apiPort"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.Api Port")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                Seri No
              </span>
              <vs-input v-validate="{required:true}"
                name="SerialNumber"
                placeholder="Seri No"
                v-model="posIpSettings.serialNumber"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.SerialNumber")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-pos-ip-settings.IP Adresi')||errors.has('form-pos-ip-settings.Device Port')||errors.has('form-pos-ip-settings.API URL')||errors.has('form-pos-ip-settings.API Port')||errors.has('form-pos-ip-settings.SerialNumber')"
                color="success"
                @click="submitPosIpSettings"
              >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>

        <div
          v-if="posIpSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1 mt-4"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">POS Fiş Nüsha Ayarları</span>
          </div>
          <form data-vv-scope="form-pos-receipt-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-4">
              <vs-col vs-w="6">
                <span class="weight-600" style="white-space: nowrap;">Müşteri Nüshası :</span><br />
                <vs-switch class="mt-2" v-model="posIpSettings.printCustomerReceipt">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
              <vs-col vs-w="6">
                <span class="weight-600" style="white-space: nowrap;">İşyeri Nüshası :</span><br />
                <vs-switch class="mt-2" v-model="posIpSettings.printMerchantReceipt">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                color="primary"
                @click="submitReceiptSettingsToDevice"
              >POS Cihazına Gönder
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import { getPosSettings,  setPosSettings} from "@/api/AppSettings";

export default {
  name: "PosSettings",
  data() {
    return {
      posIpSettings: {
        apiUrl: "",
        apiPort: "",
        deviceUrl: "",
        devicePort: "",
        serialNumber: "",
        enable: false,
        branchId: null,
        id: null,
        posType: 0,
        printMerchantReceipt: true,
        printCustomerReceipt: true
      },
    };
  },
  methods: {
    pickBool(obj, camel, pascal, fallback) {
      if (obj[camel] != null) return obj[camel];
      if (obj[pascal] != null) return obj[pascal];
      return fallback;
    },
    normalizePosSettings(data) {
      if (!data) return this.posIpSettings;
      return {
        apiUrl: data.apiUrl != null ? data.apiUrl : data.ApiUrl,
        apiPort: data.apiPort != null ? data.apiPort : data.ApiPort,
        deviceUrl: data.deviceUrl != null ? data.deviceUrl : data.DeviceUrl,
        devicePort: data.devicePort != null ? data.devicePort : data.DevicePort,
        serialNumber: data.serialNumber != null ? data.serialNumber : (data.SerialNumber != null ? data.SerialNumber : ""),
        enable: this.pickBool(data, "enable", "Enable", false),
        branchId: data.branchId != null ? data.branchId : data.BranchId,
        id: data.id != null ? data.id : data.Id,
        posType: data.posType != null ? data.posType : (data.PosType != null ? data.PosType : 0),
        printMerchantReceipt: this.pickBool(data, "printMerchantReceipt", "PrintMerchantReceipt", true),
        printCustomerReceipt: this.pickBool(data, "printCustomerReceipt", "PrintCustomerReceipt", true)
      };
    },
    updateReceiptSettingOnDevice: async function () {
      try {
        let bridgeUrl = process.env.VUE_APP_POS_API;
        if (!bridgeUrl) {
          if (!this.posIpSettings.apiUrl) return false;
          bridgeUrl = this.posIpSettings.apiUrl;
          if (this.posIpSettings.apiPort) {
            bridgeUrl += ":" + this.posIpSettings.apiPort;
          }
          if (!bridgeUrl.startsWith("http")) {
            bridgeUrl = "http://" + bridgeUrl;
          }
        }
        
        const url = bridgeUrl.endsWith("/")
          ? bridgeUrl + "set-receipt-info"
          : bridgeUrl + "/set-receipt-info";
        
        const payload = {
          IpAdress: this.posIpSettings.deviceUrl,
          SerialNumber: this.posIpSettings.serialNumber,
          ReceiptImageEnabled: this.posIpSettings.receiptImageEnabled || false,
          ReceiptJsonEnabled: this.posIpSettings.receiptJsonEnabled || false,
          ReceiptTextEnabled: this.posIpSettings.receiptTextEnabled || false,
          ReceiptWidth: this.posIpSettings.receiptWidth || "58mm",
          PrintCustomerReceipt: this.posIpSettings.printCustomerReceipt,
          PrintMerchantReceipt: this.posIpSettings.printMerchantReceipt,
          PrintCustomerReceiptCopy: this.posIpSettings.printCustomerReceiptCopy || false,
          EnableExchangeRateField: this.posIpSettings.enableExchangeRateField || false,

          ReceiptInformation: {
            ReceiptImageEnabled: this.posIpSettings.receiptImageEnabled || false,
            ReceiptJsonEnabled: this.posIpSettings.receiptJsonEnabled || false,
            ReceiptTextEnabled: this.posIpSettings.receiptTextEnabled || false,
            ReceiptWidth: this.posIpSettings.receiptWidth || "58mm",
            PrintCustomerReceipt: this.posIpSettings.printCustomerReceipt,
            PrintMerchantReceipt: this.posIpSettings.printMerchantReceipt,
            PrintCustomerReceiptCopy: this.posIpSettings.printCustomerReceiptCopy || false,
            EnableExchangeRateField: this.posIpSettings.enableExchangeRateField || false
          }
        };
        
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        if (!response.ok) return false;
        const resData = await response.json();
        return !!(resData && (
          resData.hasError === false ||
          resData.HasError === false ||
          resData.statusCode === 200 ||
          resData.StatusCode === 200
        ));
      } catch (error) {
        return false;
      }
    },
    submitPosIpSettings: async function () {
      this.posIpSettings.posType = parseInt(this.posIpSettings.posType);
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const branchId = userInfo.branch.id;
      const axiosResponse = await getPosSettings(branchId);
      this.posIpSettings.id = axiosResponse.data.id;
      const checker = await this.$validator.validateAll("form-pos-ip-settings");
      if (!checker) return;

      try {
        const res = await setPosSettings(this.posIpSettings);
        if (res && res.status === 200) {
          this.$vs.notify({
            color: "success",
            title: "Başarılı !",
            text: "Pos cihaz ayarları başarıyla veritabanına kaydedildi."
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + (res && res.status),
            text: "Pos Cihaz Ayarları Güncellenemedi !"
          });
        }
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      }
    },
    submitReceiptSettingsToDevice: async function () {
      this.posIpSettings.posType = parseInt(this.posIpSettings.posType);
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const branchId = userInfo.branch.id;
      const axiosResponse = await getPosSettings(branchId);
      this.posIpSettings.id = axiosResponse.data.id;

      const camelCaseKeys = [
        'printCustomerReceipt',
        'printMerchantReceipt',
        'receiptImageEnabled',
        'receiptJsonEnabled',
        'receiptTextEnabled',
        'receiptWidth',
        'printCustomerReceiptCopy',
        'enableExchangeRateField'
      ];
      
      camelCaseKeys.forEach(key => {
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        const value = this.posIpSettings[key] !== undefined ? this.posIpSettings[key] : false;
        this.posIpSettings[pascalKey] = value;
      });

      try {
        const res = await setPosSettings(this.posIpSettings);
        if (res && res.status === 200) {
          const bridgeOk = await this.updateReceiptSettingOnDevice();
          if (bridgeOk) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "POS Nüsha ayarları kaydedildi ve cihaza başarıyla uygulandı."
            });
          } else {
            this.$vs.notify({
              color: "warning",
              title: "Kısmen başarılı",
              text: "Ayarlar kaydedildi ancak POS cihazına (bridge) uygulanamadı. Servisin çalıştığından emin olun."
            });
          }
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + (res && res.status),
            text: "POS Fiş Nüsha Ayarları Güncellenemedi !"
          });
        }
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      }
    },
    loadPosSettings(branchId) {
      getPosSettings(branchId)
        .then((res) => {
          if (res && res.status === 200) {
            this.posIpSettings = this.normalizePosSettings(res.data);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Pos Cihaz Ayarları Bulunamadı !"
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
    },
  },
  created: async function () {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const branchId = userInfo.branch.id;
    await this.loadPosSettings(branchId);
  },
};
</script>

<style></style>
